const a = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill="currentColor" d="M1.5 0h21S24 0 24 1.5v21s0 1.5-1.5 1.5h-21S0 24 0 22.5v-21S0 0 1.5 0"></path></svg>';
export {
  a as default
};
